"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IconSettingsProvider = exports.IconSettingsContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var IconSettingsContext = /*#__PURE__*/ _react.default.createContext({});
exports.IconSettingsContext = IconSettingsContext;
var IconSettingsProvider = function(_param) {
    var children = _param.children, settings = _objectWithoutProperties(_param, [
        "children"
    ]);
    var contextValue = _react.default.useMemo(function() {
        return settings;
    }, [
        settings.classPrefix,
        settings.globalClasses
    ]);
    return /*#__PURE__*/ _react.default.createElement(IconSettingsContext.Provider, {
        value: contextValue
    }, children);
};
exports.IconSettingsProvider = IconSettingsProvider;
